/**
 * @generated SignedSource<<1d513732a4033dcf612fb599c08c11ff>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CreateDirectMobileWebJobInput = {
  clientCode: string;
  clientMutationId?: string | null;
  phone: string;
};
export type CreateDirectMobileWebJobMutation$variables = {
  input: CreateDirectMobileWebJobInput;
};
export type CreateDirectMobileWebJobMutation$data = {
  readonly createDirectMobileWebJob: {
    readonly errors?: ReadonlyArray<{
      readonly messages: ReadonlyArray<string>;
    }>;
    readonly id?: string;
    readonly mobileIntakeUrl?: string | null;
  } | null;
};
export type CreateDirectMobileWebJobMutation = {
  response: CreateDirectMobileWebJobMutation$data;
  variables: CreateDirectMobileWebJobMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "kind": "InlineFragment",
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "mobileIntakeUrl",
      "storageKey": null
    }
  ],
  "type": "Job",
  "abstractKey": null
},
v4 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "MutationError",
      "kind": "LinkedField",
      "name": "errors",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "messages",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "MutationErrors",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateDirectMobileWebJobMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "createDirectMobileWebJob",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CreateDirectMobileWebJobMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "createDirectMobileWebJob",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v2/*: any*/)
            ],
            "type": "Node",
            "abstractKey": "__isNode"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "963498d9e83bb5f8710dee6c74332e1c",
    "id": null,
    "metadata": {},
    "name": "CreateDirectMobileWebJobMutation",
    "operationKind": "mutation",
    "text": "mutation CreateDirectMobileWebJobMutation(\n  $input: CreateDirectMobileWebJobInput!\n) {\n  createDirectMobileWebJob(input: $input) {\n    __typename\n    ... on Job {\n      id\n      mobileIntakeUrl\n    }\n    ... on MutationErrors {\n      errors {\n        messages\n      }\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "b88aec074214d8ad9e4cdb4ddc7a7dae";

export default node;
